import { Box, Stack, Typography } from '@mui/material'
import { ChangeEvent, useState } from 'react'

import ArrowRight from 'assets/icons/ArrowRight.png'
import ArrowLeft from 'assets/icons/ArrowLeft.png'

import { TripResponse } from 'store/trips/trips.types'
import { Page } from 'store/common.types'
import { Tab } from '../../../types'

import TripDetails from '../trip-details/trip-details.component'
import TripSelection from '../trip-selection/trip-selection.component'

interface TripSelectionMobileProps {
  selectedTrip: TripResponse | undefined
  trips: TripResponse[]
  tabsValue: number
  setTabsValue: (value: number) => void
  refetch: () => void
  page: Page | undefined
  handlePagination: (_event: ChangeEvent<unknown>, page: number) => void
  tabs?: Tab[]
}

const TripSelectionMobile = ({
  selectedTrip,
  trips,
  tabsValue,
  setTabsValue,
  refetch,
  page,
  handlePagination,
  tabs,
}: TripSelectionMobileProps) => {
  const [detailsOpen, setDetailsOpen] = useState(false)

  return (
    <Box px={1} pt={1}>
      <Stack spacing={1}>
        <Stack
          direction="row"
          spacing={1}
          sx={{
            cursor: 'pointer',
            alignItems: 'center',
            justifyContent: detailsOpen ? 'flex-start' : 'flex-end',
          }}
          onClick={() =>
            detailsOpen ? setDetailsOpen(false) : setDetailsOpen(true)
          }
        >
          {detailsOpen ? (
            <>
              <img src={ArrowLeft} alt="arrow left" width={20} height={20} />
              <Typography>Go Back</Typography>
            </>
          ) : (
            <>
              <Typography>Go To Detail</Typography>
              <img src={ArrowRight} alt="arrow right" width={20} height={20} />
            </>
          )}
        </Stack>
        {detailsOpen ? (
          !!selectedTrip && (
            <TripDetails trip={selectedTrip} refetch={refetch} />
          )
        ) : (
          <TripSelection
            trips={trips}
            tabsValue={tabsValue}
            setTabsValue={setTabsValue}
            page={page}
            handlePagination={handlePagination}
            tabs={tabs}
            onTripsChanged={refetch}
          />
        )}
      </Stack>
    </Box>
  )
}

export default TripSelectionMobile
